
































import {
  Vue,
  Component
} from 'vue-property-decorator';
import { email, required, sameAs } from 'vuelidate/lib/validators';
import UserProfile from '@/assets/icon/user-profile.svg';

const validations = {
  newEmail: {
    required,
    email
  },
  confirmationEmail: {
    required,
    email,
    sameAsNewEmail: sameAs('newEmail')
  }
};

@Component({
  validations
})
export default class ChangeEmailForm extends Vue {
  public UserProfile = UserProfile;

  public emailErrorMessageList = {
    required: 'Leere E-Mail',
    email: 'Falsche E-Mail-Adresse',
    sameAsNewEmail: 'Die E-Mail Bestätigung entspricht nicht der E-Mail'
  };

  public newEmail: string = '';
  public confirmationEmail: string = '';

  public submit(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$store.dispatch('changeEmail', { newEmail: this.newEmail, confirmationEmail: this.confirmationEmail })
        .then(() => {
          this.$emit('closeModal');
        });
    }
  }

}
